import { render } from "./MySQL.vue?vue&type=template&id=67ff2356"
import script from "./MySQL.vue?vue&type=script&lang=js"
export * from "./MySQL.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__